import { Post } from '@/core/services/interfaces/PostInterfaces';
import {
  GENDER_LABEL_TO_TYPE,
  SENTIMENT_FROM_POLARITY,
  type Sentiment,
  type Gender,
} from '@/core/constants/domainMappings';

export type { Sentiment, Gender } from '@/core/constants/domainMappings';

export {
  SENTIMENT_FROM_POLARITY,
  SENTIMENT_COLORS,
  SENTIMENT_ICONS,
  SENTIMENT_OPTIONS,
  GENDER_ICONS,
  GENDER_OPTIONS,
} from '@/core/constants/domainMappings';

export function parseGender(value: unknown): Gender | null {
  const key = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
  return GENDER_LABEL_TO_TYPE[key] ?? null;
}

export function parseSentiment(value: unknown): Sentiment | null {
  if (value === null || value === undefined || value === '') return null;
  const key = typeof value === 'number' || typeof value === 'string' ? String(value) : '';
  return SENTIMENT_FROM_POLARITY[key] ?? null;
}

export function resolveImageUrl(post: Post): string | undefined {
  const imageAttachment = post.attachments?.find(
    (a) => a.media_type === 'IMAGE' || a.type?.startsWith('image/'),
  );
  return imageAttachment?.storage_url ?? imageAttachment?.url ?? post.image_url ?? undefined;
}

export const formatStat = (num: number | null): string | null => {
  if (num === null) return null;

  const lookup = [
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'K' },
  ];

  const item = lookup.find((i) => num >= i.value);

  if (!item) return num.toString();

  const divided = num / item.value;
  const decimalPlaces = divided >= 100 ? 0 : 1;
  const formatted = Number(divided.toFixed(decimalPlaces));

  return `${formatted}${item.symbol}`;
};

